import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    filesReceived: null,
    filesError: null,
    filesArchived: null
  },
  mutations: {
    filesReceived: (state, data) => { state.filesReceived = data },
    filesError: (state, data) => { state.filesError = data },
    filesArchived: (state, data) => { state.filesArchived = data },

    fileReceived: (state, data) => {
      state.filesReceived.push(data.file)
    },
    fileComputed: (state, data) => {
      const index = state.filesReceived.indexOf(data.file)
      if (index > -1) {
        state.filesReceived.splice(index, 1)
      }
    },
    fileError: (state, data) => {
      state.filesError.push(data.file)
    },
    fileArchived: (state, data) => {
      const paths = data.split('/')
      let current = state.filesArchived
      for (var i = 0; i < paths.length; i++ in paths) {
        const name = paths[i]
        if (i === (paths.length - 1)) {
          if (current.files.indexOf(name) === -1) {
            current.files.push(name)
          }
        } else {
          if (!current.directories[name]) {
            current.directories[name] = { directories: [], files: [] }
          }
        }
        current = current.directories[name]
      }
    }
  },
  getters: {
    filesReceived: state => JSON.parse(JSON.stringify(state.filesReceived)),
    filesError: state => JSON.parse(JSON.stringify(state.filesError)),
    filesArchived: state => JSON.parse(JSON.stringify(state.filesArchived))
  },
  actions: {
    resend (state, data) {
      socket.provider('odf', 'resend', null, data)
    }
  }
}
